<template>
  <loading v-model:active="isLoading" :is-full-page="fullPage" />
  <div v-if="!submitted">
    <div class="container-fluid">

      <img alt="Pegakorn Kft. logo" src="assets/logo.png" class="img-fluid mt-3" style="height:256px !important;">
      <h1 class="mt-3">Státusz lekérdező űrlap</h1>

      <p class="mt-2">Kérem adja meg pontosan a szerződésében található azonosítószámot, valamint pin kódját. Amennyiben
        azt
        nem tudja,
        hívja ügyfélszolgálatunkat:</p>

      <div class="row">
        <div class="col-10 col-md-5 col-lg-3 m-auto">
          <div class="alert alert-danger" role="alert" v-if="errorMessage">{{ errorMessage }}</div>
          <form>
            <div class="form-floating">
              <input v-model="crmSzam" type="crm" class="form-control" placeholder="CRM-">
              <label for="floatingInput">Szerződésazonosító</label>
            </div>
            <div class="mt-2 form-floating">
              <input v-model="pinCode" type="pincode" class="form-control" placeholder="Pin">
              <label for="floatingPassword">Pin kód</label>
            </div>
            <button class="mt-5 w-100 btn btn-lg btn-secondary" type="button" @click="query">Lekérdezés</button>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="container-fluid">
      <div
        class="panel-heading d-flex flex-column flex-md-row align-items-center p-3 px-md-4 mb-3 bg-white border-bottom box-shadow">
        <a href="#" class="pull-left">
          <span><img alt="Pegakorn Kft. logo" src="assets/logo.png" style="height:50px"></span>
        </a>
        <h3 style="margin: 0; padding: 0; font-weight: bold;" class="py-3 px-3">Státusz lekérdezés</h3>
      </div>

      <StepProgressBar :steps="steps" :current-step="step" :short-steps="short_step" :completed-step="step - 1"
        :disable-navigation="true" />


      <div class="row">

        <div class="col-lg-9 offset-lg-1">
          <table class="table table-bordered mx-auto">
            <tbody>
              <tr>
                <th scope="row">Szerződésazonosító</th>
                <td>{{ details.sorszam }}</td>
              </tr>
              <tr>
                <th scope="row">Település</th>
                <td>{{ details.telepules }}</td>
              </tr>
              <tr>
                <th scope="row">Cím</th>
                <td>{{ details.cim }}</td>
              </tr>
              <tr>
                <th scope="row">Ügye ennyi napja tart</th>
                <td style="font-weight: bold">{{ elteltNapokOsszesen }}</td>
              </tr>
              <tr>
                <th scope="row">Jelenlegi státusz</th>
                <td style="font-weight: bold"><span class="text-success">{{ foStatusz }}</span></td>
              </tr>
              <tr>
                <th scope="row">Állapot</th>
                <td style="font-weight: bold"><span class="text-success">{{ belsoStatusz }}</span></td>
              </tr>
              <tr>
                <th scope="row">Készültségi szint</th>
                <td style="font-weight: bold"><span class="text-success">{{ percentage }}%</span></td>
              </tr>
              <tr>
                <th scope="row">Jelenlegi státusz eltelt napok száma</th>
                <td style="font-weight: bold">{{ elteltNapokStep }}</td>
              </tr>
              <tr>
                <th scope="row">Jelenlegi státusz határideje</th>
                <td style="font-weight: bold">{{ hataridoNapok }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <h1>Előzmények</h1>
      <div class="row">
        <div class="col-lg-12">
          <div class=" table-responsive-md table-responsive-lg table-responsive-sm ">
            <table class="table table-bordered mx-auto">
              <thead>
                <tr>
                  <th scope="row">Dátum</th>
                  <th scope="row">Státusz</th>
                  <th scope="row">Állapot</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in history" :key="item.id">
                  <td>{{ item.datum }}</td>
                  <td>{{ item.fo_statusz }}</td>
                  <td>{{ item.belso_statusz }}</td>
                </tr>
                <tr v-if="!history.length">
                  <td colspan="4">Nincs megjeleníthető rekord</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import StepProgressBar from "@/components/StepComponent.vue";
import 'vue-loading-overlay/dist/css/index.css';



export default {
  name: 'App',
  data() {
    return {
      crmSzam: '',
      pinCode: '',
      errorMessage: '',

      steps: [
        { label: '1. MVM igénybejelentés (személyes adatok feldolgozása egyeztetése)' },
        { label: '2. MVM igénybejelentés (műszaki adatok feldolgozása egyeztetése)' },
        { label: '3. MVM visszaigazolás (igénybejelentés,ügyfél befizetés)' },
        { label: '4. E-KÖZMŰ (tervegyeztetés)' },
        { label: '5. TERV (engedélyeztetés)' },
        { label: '6. MVM logisztika (anyag igénylés)' },
        { label: '7. KÖZTERÜLET (földmunka alépítmény)' },
        { label: '8. ÜTEMEZÉS (MVM hálózati engedély kérés)' }],
      short_step: [
        { label: '1.' },
        { label: '2.' },
        { label: '3.' },
        { label: '4.' },
        { label: '5.' },
        { label: '6.' },
        { label: '7.' },
        { label: '8.' }],

      submitted: false,
      details: undefined,
      fullPage: true,
      isLoading: false,

      step: undefined,
      belsoStatusz: undefined,
      foStatusz: undefined,
      history: undefined,
      percentage: undefined,
      elteltNapokOsszesen: undefined,
      hataridoNapok: undefined,
      elteltNapokStep: undefined,
      lejart: undefined,
    }
  },
  components: {
    Loading, StepProgressBar
  },
  created() {
    const params = new URLSearchParams(window.location.search)
    const crmszam = params.get('crmszam')
    const pincode = params.get('pincode')
    this.crmSzam = crmszam
    this.pinCode = pincode
    if (this.crmSzam != "" && this.pinCode != "" && this.crmSzam != null && this.pinCode != null) {
      this.query()
    }
  },
  methods: {
    query() {
      this.getDetails()

    },
    getDetails() {

      this.isLoading = true
      this.axios.get("https://dankovill.duckdns.org/status?crmid=" + this.crmSzam + "&pincode=" + this.pinCode).then((response) => {
        this.isLoading = false
        this.errorMessage = ""
        this.submitted = true
        this.details = response.data

        if(response.data.elso_nap_ota_eltelt_nap == -1) {
          this.elteltNapokOsszesen = "Nincs adat jelenleg"
        } else {
          this.elteltNapokOsszesen = response.data.elso_nap_ota_eltelt_nap + " nap"
        }

        if(response.data.hatarido_napok == -1 || response.data.hatarido_napok == 0) {
          this.hataridoNapok = "Nincs adat jelenleg"
        } else {
          this.hataridoNapok = response.data.hatarido_napok + " nap"
        }

        if(response.data.eltelt_napok == -1) {
          this.elteltNapokStep = "Nincs adat jelenleg"
        } else {
          this.elteltNapokStep = response.data.eltelt_napok + " nap"
        }
        this.lejart = response.data.letelt

        this.foStatusz = this.mapFelelosUserId(response.data.fo_statusz)
        this.belsoStatusz = this.mapStatusz2(response.data.belso_statusz)
        this.history = this.getHistoryRecords(response.data.elozmenyek)
        this.step = parseInt(this.mapStepFromFelelosUserId(response.data.elert_statusz))

        if (this.step == 8) {
          this.percentage = 92.5

          if (response.data.belso_statusz == "-1" || response.data.belso_statusz == "1710") {
            this.step = 9
            this.percentage = 100
          }
        } else {
          if (response.data.belso_statusz == "1710") {
            this.percentage = (this.step) / 8 * 100
          } else {
            if (this.step == 0) {
              this.percentage = 0
            } else {
              this.percentage = (this.step - 1) / 8 * 100
            }
          }
          
        }

        if(this.step == undefined || this.step == null || isNaN(this.step)) {
          this.percentage = 0
        }


      }).catch((error => {
        this.errorMessage = this.mapErrorMessages(error.response.data.error)
        this.isLoading = false
      }))
    },
    mapErrorMessages(errorMessage) {
      if (errorMessage == null || errorMessage == undefined) {
        return "HIBA: Ismeretlen hiba! Próbálja újra később!"
      }
      switch (errorMessage) {
        case "invalid CRM given":
          return "HIBA: Hibás szerződésazonosító formátum!"
        case "pin code not given":
          return "HIBA: Nem adta meg a pin kódot! Ha nem rendelkezik pin kóddal, keresse fel ügyfélszolgálatunkat!"
        case "crm id not given":
          return "HIBA: Nem adta meg a szerződésazonosítót!"
        case "error on request":
          return "HIBA: Szerver oldali probléma merült fel! Próbálja újra később!"
        case "Not existing crm":
          return "HIBA: Nem létező szerződésazonosító!"
        case "pin code mismatch":
          return "HIBA: A pin kód amit megadott nem megfelelő a szerződésazonosítóhoz!"
        default:
          return "HIBA: Ismeretlen hiba. Próbálja újra később!"
      }
    },
    mapStepFromFelelosUserId(userId) {
      var userIdMap = {
        "42": "1",
        "68": "2",
        "46": "3",
        "64": "4",
        "52": "4",
        "32": "5",
        "51": "6",
        "57": "7",
        "53": "8",
        "45": "8",
        "66": "8",
        "67": "8",
        "14": "8",
        "-1": "8"
      }
      var exist = userId in userIdMap

      if (exist) {
        return userIdMap[userId]
      } else {
        return "Akadály"
      }
    },
    mapFelelosUserId(userId) {
      var userIdMap = {
        "42": "1. MVM igénybejelentés (személyes adatok feldolgozása egyeztetése)",
        "68": "2. MVM igénybejelentés (műszaki adatok feldolgozása egyeztetése)",
        "46": "3. MVM visszaigazolás (igénybejelentés,ügyfél befizetés)",
        "64": "4. E-KÖZMŰ (tervegyeztetés)",
        "52": "4. E-KÖZMŰ (tervegyeztetés)",
        "32": "5. TERV (engedélyeztetés)",
        "51": "6. MVM logisztika (anyag igénylés)",
        "57": "7. KÖZTERÜLET (földmunka alépítmény)",
        "53": "8. ÜTEMEZÉS (MVM hálózati engedély kérés)",
        "45": "8. ÜTEMEZÉS (MVM hálózati engedély kérés)",
        "66": "8. ÜTEMEZÉS (MVM hálózati engedély kérés)",
        "67": "8. ÜTEMEZÉS (MVM hálózati engedély kérés)",
        "14": "8. ÜTEMEZÉS (MVM hálózati engedély kérés)",
        "17": "MVM manager (műszaki gazdasági feltételek)",
        "5": "MVM manager (műszaki gazdasági feltételek)",
        "-1": "8. ÜTEMEZÉS (MVM hálózati engedély kérés)"
      }
      var exist = userId in userIdMap

      if (exist) {
        return userIdMap[userId]
      } else {
        return "Akadály"
      }
    },
    mapStatusz2(statusz2) {
      var statusz2Map = {
        "672": "Nyitott",
        "673": "Folyamatban",
        "674": "Akadály",
        "675": "Hiánypótlás",
        "1710": "Kész",
        "1711": "Beszállítás alatt",
        "1712": "Ütemezve",
        "1713": "Ügyfél válaszára vár",
        "-1": "Kész"
      }
      var exist = statusz2 in statusz2Map

      if (exist) {
        return statusz2Map[statusz2]
      } else {
        return "Akadály"
      }
    },
    getHistoryRecords(records) {
      if (records == undefined || records == null) {
        return []
      }

      var output = []
      records.forEach(element => {
        var id = 0
        var belso_statusz = this.mapStatusz2(element.belso_statusz)
        var fo_statusz = this.mapFelelosUserId(element.fo_statusz)
        if (fo_statusz != "Akadály") {
          id++
          output.push({
            "id": id,
            "belso_statusz": belso_statusz,
            "fo_statusz": fo_statusz,
            "datum": element.datum
          })
        }
      });
      return output
    },
    background(szam) {
      if (this.step > szam) {
        return "bg-success text-light"
      }
      else if (this.step == szam) {
        if (this.belsoStatusz == "Kész") {
          return "bg-success text-light"
        } else {
          return "bg-warning"
        }
      }
      return ""
    }
  }

}

</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
